import React, { useState, Fragment, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import {
  DropdownWrapper,
  FlexWrapper,
  FormFlexWrapper,
  FormGroup,
  FormGroupWrapper,
  SelectCustomStyles,
  Error,
  CommonLabel,
} from "@app/components/commonStyles";
import { Input, Button, Radio, Toast } from "@app/components";
import { gradesList, preferedPronounList, useLocation } from "@app/utils";
import { updateUser, getSchoolDetails } from "@app/services";
import { ButtonContainer } from "../sign-up.component";
import ChangeAccountDialog from "./change-account-dialog";
import { AuthContext } from "@app/providers";
import { getDefaultUrl } from "../../../routes/route-helpers";
type Props = {
  setShowSuccess: (e: any) => void;
  setEducatorDetails: (e: any) => void;
};

export default function EducatorSchoolLicense({
  setShowSuccess,
  setEducatorDetails,
}: Props) {
  const { register, handleSubmit, errors, setValue, control }: any = useForm({
    mode: "onSubmit",
  });
  const { navigate } = useLocation();
  const [schoolCodeValid, setSchoolCodeValid] = useState(false);
  const [schoolCodeError, setSchoolCodeError] = useState<string>("");
  const [buttonText, setButtonText] = useState<string>("Continue");
  const [schoolData, setSchoolData] = useState<any>();
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [showToast, setShowToast] = useState(false);
  // const { userInfo, setUserInfo }: any = useContext(AuthContext);
  const defaultUrl: string = getDefaultUrl(userInfo && userInfo.userJson);

  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  let educatorData: any = localStorage.getItem("teacherData");
  educatorData = educatorData ? JSON.parse(educatorData) : null;

  function onSubmit(data: any) {
    setButtonText("Submitting...");
    const gradeArray: any[] = data.grade.map(function (item: any) {
      return item["value"];
    });
    const params: any = {};
    Object.assign(params, {
      userType: "educator",
      userId: educatorData.userId,
      sessionToken: educatorData.sessionToken,
      educatorLicenseType: data.licenseType,
      schoolRegCode: schoolData.schoolCode,
      schoolName: schoolData.schoolName,
      schoolCity: schoolData.schoolCity,
      schoolZip: schoolData.schoolZip,
      educatorGrade: gradeArray.join(","),
      preferedPronoun: data.preferedPronoun,
    });
    updateUser(params)
      .then((resp) => {
        const response = resp;
        if (response._responseStatus === 1) {
          setButtonText("Submit");
          // localStorage.removeItem("accountType");
          // localStorage.removeItem("educatorData");
          setEducatorDetails(response);
          setShowSuccess(true);
        } else if (response.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setButtonText("Submit");
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        setButtonText("Submit");
        console.log(err, "signupError");
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again.`,
        });
        setShowToast(true);
      });
  }

  function onChange(data: any) { }

  function onSchoolCodeSubmit(data: any) {
    setButtonText("Continuing...");
    const params: any = {};
    Object.assign(params, {
      schoolCode: data.schoolCode,
      userId: educatorData.userId,
      sessionToken: educatorData.sessionToken,
    });
    getSchoolDetails(params)
      .then((resp) => {
        const response = resp;
        if (response._responseStatus === 1) {
          const { schoolDetails = {} } = response;
          const schoolData: any = JSON.parse(schoolDetails);
          setSchoolCodeValid(true);
          setButtonText("Submit");
          setValue("schoolCode", schoolData.schoolCode);
          setValue("schoolName", schoolData.schoolName);
          setValue("schoolAddress", schoolData.schoolCity);
          setValue("schoolpinCode", schoolData.schoolZip);
          setSchoolData(schoolData);
        } else if (response.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
          // setTimeout(() => {
          //   localStorage.clear();
          //   setUserInfo(null);
          //   navigate("/sign-in");
          // }, 5000);
        } else {
          setButtonText("Continue");
          setSchoolCodeError(response.msg);
        }
      })
      .catch((err) => {
        console.log(err, "schoolCodeError");
        setButtonText("Continue");
      });
  }

  function Portal() {
    navigate('/educator')
  }

  if (!schoolCodeValid) {
    return (
      <Fragment>
        <form
          className="signup-form"
          onSubmit={handleSubmit(onSchoolCodeSubmit)}
          onChange={onChange}
        >
          <FormGroupWrapper>
            <FormGroup>
              <FlexWrapper className="justify-between mt-2">
                <Radio
                  name="licenseType"
                  id="license_1"
                  value="schoolLicenseCode"
                  register={register({
                    required: true,
                  })}
                  label="Already have a school license code"
                  checked={true}
                  className="m-0"
                />
                {/* <button
                  className="anchor-tag"
                  type="button"
                  onClick={() => setShowDialog(!showDialog)}
                >
                  Change
                </button> */}
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <FormFlexWrapper>
                <div className="child only-child">
                  <Input
                    hideLabel={true}
                    label="School Code"
                    placeholder="School Code"
                    name="schoolCode"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    autoFocus={true}
                    onChange={(e) => setSchoolCodeError("")}
                    error={
                      (errors.schoolCode && "Please enter School Code") ||
                      (schoolCodeError && schoolCodeError)
                    }
                  />
                </div>
              </FormFlexWrapper>
            </FormGroup>
          </FormGroupWrapper>
          <FlexWrapper style={{ display: "block" }}>
            <ButtonContainer disabled={buttonText === "Continuing..."}>
              <Button
                variant="newsecondary"
                size="large"
                width="100%"
                type="submit"
              >
                {buttonText}
              </Button>
            </ButtonContainer>
            <ButtonContainer style={{ marginTop: "15px" }}>
              <Button onClick={() => Portal()}
                variant="bordered"
                size="large"
                width='100%'>
                Cancel
              </Button>
            </ButtonContainer>
          </FlexWrapper>
        </form>
        {showDialog && (
          <ChangeAccountDialog
            onClose={() => setShowDialog(false)}
            onChangeLicense={() => navigate("./sign-up/educator")}
          />
        )}
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <form
          className="signup-form"
          onSubmit={handleSubmit(onSubmit)}
          onChange={onChange}
        >
          <FormGroupWrapper>
            <FormGroup>
              <FlexWrapper className="justify-between mt-2">
                <Radio
                  name="licenseType"
                  id="license_1"
                  value="schoolLicenseCode"
                  register={register({
                    required: true,
                  })}
                  label="Already have a school license code"
                  checked={true}
                  className="m-0"
                />
                {/* <button
                  className="anchor-tag"
                  onClick={() => setShowDialog(!showDialog)}
                >
                  Change
                </button> */}
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <Input
                    hideLabel={true}
                    label="School Id"
                    placeholder="School Id"
                    name="schoolCode"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    disable={true}
                    isValid={true}
                  />
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <Input
                    hideLabel={true}
                    label="School Name"
                    placeholder="School Name"
                    name="schoolName"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    disable={true}
                    error={errors.schoolName && "Please enter School Name"}
                  />
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="two-child-layout mb-0">
                <div className="child">
                  <Input
                    hideLabel={true}
                    label="School Address"
                    placeholder="School Address"
                    name="schoolAddress"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    disable={true}
                    error={
                      errors.schoolAddress && "Please enter School Address"
                    }
                  />
                </div>
                <div className="child">
                  <Input
                    hideLabel={true}
                    label="School Pincode"
                    placeholder="School Pincode"
                    name="schoolpinCode"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    disable={true}
                    error={
                      errors.schoolpinCode && "Please enter School Pincode"
                    }
                  />
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <DropdownWrapper>
                    <Controller
                      as={Select}
                      value="value"
                      name="grade"
                      options={gradesList}
                      placeholder="Grade"
                      control={control}
                      rules={{ required: true }}
                      styles={SelectCustomStyles}
                      defaultValue={""}
                      isMulti={true}
                      closeMenuOnSelect={false}
                    />
                    {errors.grade && (
                      <Error>Please select atleast one Grade</Error>
                    )}
                  </DropdownWrapper>
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <CommonLabel className="mb-1">Preferred Pronouns</CommonLabel>
                  <FlexWrapper>
                    {preferedPronounList.map((each: any) => (
                      <Radio
                        name="preferedPronoun"
                        id={"pronoun_" + each.value}
                        value={each.value}
                        register={register({
                          required: true,
                        })}
                        label={each.label}
                        className="mb-sm-1 mb-0"
                      />
                    ))}
                  </FlexWrapper>
                  {errors.preferedPronoun && (
                    <Error className="checkbox-error">
                      Please select Preferred Pronouns
                    </Error>
                  )}
                </div>
              </FormFlexWrapper>
            </FormGroup>
          </FormGroupWrapper>
          <FlexWrapper className="mt-3" style={{ display: "block" }}>
            <ButtonContainer disabled={buttonText === "Submitting..."}>
              <Button
                variant="newsecondary"
                size="large"
                width="100%"
                type="submit"
              >
                {buttonText}
              </Button>
            </ButtonContainer>
            <ButtonContainer style={{ marginTop: "15px" }}>
              <Button onClick={() => setSchoolCodeValid(false)}
                variant="bordered"
                size="large"
                width='100%'>
                Cancel
              </Button>
            </ButtonContainer>
          </FlexWrapper>
        </form>
        {showDialog && (
          <ChangeAccountDialog
            onClose={() => setShowDialog(false)}
            onChangeLicense={() => navigate("./sign-up/educator")}
          />
        )}
        <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          onClose={() => setShowToast(false)}
        />
      </Fragment>
    );
  }
}
